export const AR = {
    header: 'تواصل معنا',
    title: 'تواصل معنا',
    phone:'01112644891',
    email:'Company@alyansmine.com',
    address:'إسكندريه /سموحه',
}

export const USA = {
    header: 'Contact Us',
    title: 'Contact Us',
    phone:'01112644891',
    email:'Company@Alyansmine.com',
    address:'Alexandria/Smouha',
}